import { render, staticRenderFns } from "./InventarioTabContent.vue?vue&type=template&id=6e52ce56&scoped=true"
import script from "./InventarioTabContent.vue?vue&type=script&lang=js"
export * from "./InventarioTabContent.vue?vue&type=script&lang=js"
import style0 from "./InventarioTabContent.vue?vue&type=style&index=0&id=6e52ce56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e52ce56",
  null
  
)

export default component.exports